import { render, staticRenderFns } from "./biyeAuditCjy.vue?vue&type=template&id=f0cb6d1a&scoped=true"
import script from "./biyeAuditCjy.vue?vue&type=script&lang=js"
export * from "./biyeAuditCjy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cb6d1a",
  null
  
)

export default component.exports